import React, { useState, useEffect, useRef } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db, auth, storage } from "../api/firebase";
import {
  ref,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from "firebase/storage";
import defaultBackImg from "../data/img/defaultImage.png";
import LoaderBackImg from "./LoaderBackImg";
import Camera from "../data/svg/Camera";
import Loading from "./Loading";
import Blind from "./Blind";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useParams } from "react-router-dom";

const MovieChannelTopImage = () => {
  const {id} = useParams()
  const [user] = useDocumentData(doc(db, "user", auth.currentUser.uid));
  const [channel] = useDocumentData(doc(db, "movieChannel", id));

  //   背景画像コンテナ
  const [backImg, setBackImg] = useState("");
  //   セットコンテナ
  const [isLoading, setIsLoading] = useState("");
  //   背景画像Ref
  const backImgRef = useRef(null);

  // プロフィール画像変更処理
  useEffect(() => {
    if (backImg) {
      setIsLoading(true);

      const uploadBackImg = async () => {
        const backImgRef = ref(
          storage,
          `movieChannnelBackground/${new Date().getTime()} - ${backImg.name}`
        );
        try {
          if (channel?.backgroundPath) {
            await deleteObject(ref(storage, channel?.backgroundPath));
          }

          const snap = await uploadBytes(backImgRef, backImg);
          const url = await getDownloadURL(ref(storage, snap.ref.fullPath));

          await updateDoc(doc(db, "movieChannel", id), {
            background: url,
            backgroundPath: snap.ref.fullPath,
          });
          // console.log(backImg)
          setBackImg("");
          // window.location.reload();
          setIsLoading(false);
        } catch (err) {
          console.log(err.message);
        }
      };
      uploadBackImg();
    }
  }, [backImg]);

  if (isLoading) {
    return (
      <>
        <Blind blind={true} />
        <Loading title="プロフィール" action="更新中" />;
      </>
    );
  }
  return (
    <>
      <div
        className={`relative ${
          user?.isAdmin ||
          (channel?.creator === auth.currentUser.uid &&
            " hover:opacity-50 cursor-pointer")
        } flex justify-center items-center w-full  group`}
      >
        <div className=" absolute bottom-0 left-o w-full h-20 bg-gradient-to-t from-white to-transparent " />
        {channel?.background ? (
          <img
            src={channel?.background || defaultBackImg}
            object-fit="cover"
            className="w-full h-96 rounded-t-md"
            alt=""
            onClick={() => backImgRef.current.click()}
          />
        ) : defaultBackImg ? (
          <img
            src={defaultBackImg}
            alt="バックイメージ"
            className="w-full h-72 rounded-t-md"
          />
        ) : (
          <LoaderBackImg />
        )}
        {user?.isAdmin ||
          (channel?.creator === auth.currentUser.uid && (
            <div
              className="absolute top-2   sm:hidden group-hover:flex text-gray-200 sm:text-black opacity-80 hover:opacity-100 duration-300"
              onClick={() => backImgRef.current.click()}
            >
              <Camera className="" />
              <input
                ref={backImgRef}
                onChange={(e) => setBackImg(e.target.files[0])}
                type="file"
                hidden
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default MovieChannelTopImage;
